import script from "./EventView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventView.vue?vue&type=script&setup=true&lang=ts"

import "./EventView.vue?vue&type=style&index=0&id=faf71b0e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_d0e91f904bb1d11c0b68168201cc497f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-faf71b0e"]])

export default __exports__